export const DOMESTICBANK_DEFINITIONS = "/DomesticBankDef/GetUsersPayFacIntegrationEnabledBankList"
export const DOMESTICBANK_INSERT = "/DomesticBankDef/InsertDomesticBankDef"
export const DOMESTICBANK_UPDATE = "/DomesticBankDef/UpdateDomesticBankDef"
export const DOMESTICBANK_DELETE = "/DomesticBankDef/DeleteDomesticBankDef"
export const DOMESTICBANK_DEFINITIONS_GET_USERNAME = "/DomesticBankDef/GetPayFacCommissionBankListByUserName"